/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Bottom_LeftInputs */

const en_mobile_scan_bottom_left = /** @type {(inputs: Mobile_Scan_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom left corner`)
};

const es_mobile_scan_bottom_left = /** @type {(inputs: Mobile_Scan_Bottom_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esquina inferior izquierda`)
};

/**
* | output |
* | --- |
* | "Bottom left corner" |
*
* @param {Mobile_Scan_Bottom_LeftInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_bottom_left = /** @type {((inputs?: Mobile_Scan_Bottom_LeftInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Bottom_LeftInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_bottom_left(inputs)
	return en_mobile_scan_bottom_left(inputs)
});